import type { CSSObject } from '@emotion/react'

/**
 * These rules visually hide content, but leave it accessible to screen
 * readers. This is useful for providing text alternatives to purely-visual UI
 * elements. (For example, icons or toggle switches.)
 *
 * @note Prefer using `<VisuallyHidden>` from `@radix-ui/react-visually-hidden`. Only use this when you’re customizing
 * a monolithic component’s styling — for example, to hide `<TextInput>`’s error message.
 *
 * @see https://webaim.org/techniques/css/invisiblecontent/ 'CSS clip'
 **/
export const screenreaderOnly: CSSObject = {
  clip: 'rect(1px, 1px, 1px, 1px)',
  clipPath: 'inset(50%)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
}
